

export const environment = {
  production: false,

  apiUrl: 'https://logixpense.com:1001',

  // // apiUrl: 'https://logixpense.com:2001',
  // apiUrl: 'https://logixpense.com:96',
  apiUrlGlad: 'https://logixpense.com:2924',
  version: ''
};

